import { DefaultButton } from "../../../../../common/components/button/defaultButton/DefaultButton";
import { showCustomConfirmDialog } from "../../../../../common/components/dialogs/AppConfirmDialog";
import { getMonogram } from "../../../../linkPage/utils/linkPageIconUtility";
import { useStudioLogo } from "./hooks/useStudioLogo";
import styles from "./StudioLogoField.module.scss";

interface IStudioLogoFieldProps {
  studioId: number;
  studioName: string;
  logoUrl: string | null;
  /** Same width the wizard hands its other fields, so the block lines up with them. */
  width?: string;
}

/**
 * Logo upload for the studio. Unlike the rest of the wizard this saves immediately — the file
 * goes to storage the moment it is picked, so there is nothing to lose if the form is abandoned.
 */
export const StudioLogoField = ({
  studioId,
  studioName,
  logoUrl: studioLogoUrl,
  width,
}: IStudioLogoFieldProps) => {
  const {
    fileInputRef,
    logoUrl,
    isUploading,
    openFilePicker,
    uploadLogo,
    removeLogo,
  } = useStudioLogo(studioId, studioLogoUrl);

  const confirmRemove = () =>
    showCustomConfirmDialog(
      "Сигурни ли сте, че искате да премахнете логото?",
      removeLogo,
    );

  return (
    <div className={styles.root} style={{ width }}>
      <span className={styles.root_label}>Лого на обекта</span>

      <div className={styles.root_body}>
        <div className={styles.root_body_preview}>
          {logoUrl ? (
            <img
              className={styles.root_body_preview_image}
              src={logoUrl}
              alt="Лого на обекта"
            />
          ) : (
            <span className={styles.root_body_preview_monogram}>
              {getMonogram(studioName, 2) || "?"}
            </span>
          )}
        </div>

        <div className={styles.root_body_actions}>
          <DefaultButton
            label={logoUrl ? "Смени" : "Качи лого"}
            design="outline"
            type="button"
            width="auto"
            loading={isUploading}
            onClick={openFilePicker}
          />

          {!!logoUrl && (
            <DefaultButton
              label="Премахни"
              design="link"
              type="button"
              width="auto"
              disabled={isUploading}
              onClick={confirmRemove}
            />
          )}
        </div>
      </div>

      <p className={styles.root_hint}>
        JPG, PNG, GIF, WEBP или BMP, до 5 MB. Показва се на линк страницата
        и на началния екран; без лого се показва само името на обекта.
      </p>

      <input
        ref={fileInputRef}
        type="file"
        accept="image/*,.heic,.heif"
        className={styles.root_input}
        onChange={uploadLogo}
      />
    </div>
  );
};
